import React from 'react';
import styles from './index.module.less';
import { FooterContext } from '../../common';
import { ReoIcon } from '@reolink-web/components.basic';
import eventBus from '@/utils/event';
import * as sitePath from '@/utils/function/sitePath';
import classNames from 'classnames';
const CompFooterCopyright: React.FC = () => {
    const { getTextByKey, countryTitle, isEuCountry, country } = React.useContext(FooterContext);

    const handleCountrySelectClick = React.useCallback(() => {
        // 未加载出国家时点击无效
        if (!countryTitle) {
            return;
        }
        eventBus.emit('countryLangModalOpen', {});
    }, [countryTitle]);

    const footerBottomLinks = React.useMemo(() => {
        return [
            {
                key: 'privacy-policy',
                link: sitePath.getOfficialSitePath('/privacy-policy'),
            },
            {
                key: 'terms-conditions',
                link: sitePath.getOfficialSitePath('/terms-conditions'),
            },
            ...(country === 'US'
                ? [
                    {
                        key: 'accessibility',
                        link: sitePath.getOfficialSitePath('/accessibility'),
                    },
                ]
                : []),
        ];
    }, [country]);

    const euBottomLinks = React.useMemo(() => {
        return [
            {
                key: 'cookie-policy',
                link: sitePath.getOfficialSitePath('/cookie-policy/'),
            },
            {
                key: 'declaration-of-conformity',
                link: 'https://home-cdn.reolink.us/wp-content/assets/2021/05/EU-DOC.zip?download_name=EU-DOC.zip',
            },
        ];
    }, []);

    return (
        <div className={ styles['copyright-container'] }>
            <div className={ styles['link-with-copy-right'] }>
                <ul className={ styles['bottom-link-list'] }>
                    {footerBottomLinks.map((item) => {
                        return (
                            <li
                                className={ styles['bottom-link-item'] }
                                key={ item.key }>
                                <a
                                    className={ styles['bottom-link'] }
                                    href={ item.link }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {getTextByKey(item.key)}
                                </a>
                            </li>
                        );
                    })}
                    {isEuCountry ? (
                        <>
                            {euBottomLinks.map((item) => {
                                return (
                                    <li
                                        className={ classNames(styles['bottom-link-item'], {
                                            [styles['cookie-policy']]: item.key === 'cookie-policy',
                                        }) }
                                        key={ item.key }
                                    >
                                        <a
                                            className={ styles['bottom-link'] }
                                            href={ item.link }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {getTextByKey(item.key)}
                                        </a>
                                    </li>
                                );
                            })}
                        </>
                    ) : null}
                </ul>
                <div className={ styles['copyright-text'] }>
                    {getTextByKey('copyright-text').replace('{year}', new Date().getFullYear().toString())}
                </div>
            </div>
            <div className={ styles['country-content'] }>
                <div
                    className={ styles['country-select'] }
                    onClick={ handleCountrySelectClick }>
                    <p className={ styles['country-select-country'] }>{countryTitle}</p>
                    <ReoIcon
                        name={ 'icon-icon_arrow-down' }
                        className={ styles['country-select-icon'] } />
                </div>
            </div>
        </div>
    );
};
export default CompFooterCopyright;
